module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutview"
  }, [_c('c-head'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('span', {
      class: {
        'active': _vm.tabIndex === index
      },
      on: {
        "click": function($event) {
          _vm.tab(index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "nav-content",
    domProps: {
      "innerHTML": _vm._s(_vm.article)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-89eea086!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/about.vue
// module id = 36
// module chunks = 1